import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { DeleteChannelGuideDocument } from '../channel-guides/delete.generated';
import { useNotifications, type ApiOptions } from '../helpers';

export const useDeleteChannelGuide = (
  options: ApiOptions<typeof DeleteChannelGuideDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(DeleteChannelGuideDocument, {
    ...useNotifications(DeleteChannelGuideDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: (data) => {
        const count = data.deleteChannelGuide?.deletedIds.length ?? 0;
        return t('api.channel_guides.delete_success_plural', { count });
      },
    }),
    update(cache, { data }) {
      if (!data?.deleteChannelGuide?.deletedIds.length) return;
      data.deleteChannelGuide.deletedIds.forEach((id) => cache.evict({ id: `ChannelGuide:${id}` }));
    },
    ...options,
  });
};
